<template>
  <div class="py-16 px-4 overflow-hidden">
    <post-login-registration-form></post-login-registration-form>
  </div>
</template>

<script>
import PostLoginRegistrationForm from "../components/PostLoginRegistrationForm";
export default {
  name: "UpdateDisplayName",
  components: { PostLoginRegistrationForm }
};
</script>

<style scoped></style>
